import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, SelectInput, TextInput, Button, TopToolbar, FormDataConsumer, required, NumberInput, SelectField, FunctionField, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, SaveButton, useNotify, SimpleFormIterator, ArrayInput, ArrayField, useUpdate } from 'react-admin';import { useStyles  } from '../common/styles';

import EditIcon from '@material-ui/icons/Edit';

import Divider from '@mui/material/Divider';


import { useTranslate  } from '../common/language';

import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { choicesHealthyType, choicesHealthyFederation, choicesHealthyPeriodicity, choicesHealthyFormal } from './../common/constants';
  

import { validateMaxLength, validateInteger  } from './../components/Validator';


export const UsersHealthyList = (props) => {
  const translate = useTranslate();  
    
  let strRedirect =  `/users/${props.users_id}/more_federation`; 
    
  return (
    <ResourceContextProvider value="users_healthy" >
      <List 
        syncWithLocation 
        basePath="/users_healthy" 
        filter={{ users_id : props.users_id }}  
        title=""
        bulkActionButtons={false}                
        actions={<CustomToolbar users_id={props.users_id} /> }  
        perPage={1000}
        sort={{ field: 'year', order: 'ASC' }} 
        empty={<CustomToolbar users_id={props.users_id} /> } 
        pagination={false}
      >        
        <Datagrid   
          expand={<UsersHealthyDetails />} 
          className="header_grey6"
          label=""
          fullWidth
        >
          <TextField source="year" label={translate('common.year')} sortable={false} /> 
          <FunctionField label={translate('users_healthy.total_quantity' )} render={record => <RenderTotalQuantity record={record} /> } sortable={false} />
          <FunctionField label={translate('users_healthy.total_students' )} render={record => <RenderTotalStudents record={record} /> } sortable={false} />
          <FunctionField label={translate('users_healthy.total_teachers_workers')} render={record => <RenderTotalTeachersWorkers record={record} /> } sortable={false} />
          <FunctionField label={translate('users_healthy.total_teachers_volunteers')} render={record => <RenderTotalTeachersVolunteers record={record} /> } sortable={false} />
          <CustomEditButton label="" />
          <DeleteButton undoable={false} redirect={strRedirect} label=""/>
        </Datagrid>     
      </List>
    </ResourceContextProvider>
  );
};


export const CustomEditButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [update, { loading, error }] = useUpdate();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };
                        
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'users_healthy', 
        payload : { id: values.id, data : 
                {       users_id: values.users_id,
                  year : values.year, 
                  items: values.items
                } }
      },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    

  return (
    <>
      <Button onClick={handleClick} label="" startIcon={<EditIcon />} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
      >
        <DialogTitle>{translate('users_healthy.edit')}</DialogTitle>

        <FormWithRedirect
          resource=""
          save={handleSubmit}
          initialValues={{ id : props.record.id, 
            users_id: props.record.users_id,
            year : props.record.year, 
            items: props.record.items
          }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <CustomForm edit={true} />
                            
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const RenderTotalQuantity = ({ record, ...props }) => {
    
  let total_quantity = 0;
  if (record.items)
  {
    record.items.forEach(element => { total_quantity+=1; } );
  }
    
  return ( total_quantity );
    
};

const RenderTotalStudents = ({ record, ...props }) => {
    
  let total_quantity = 0;
  if (record.items)
  {
    record.items.forEach(element => { total_quantity+=(element.profile_1_male+element.profile_1_female+element.profile_1_no_binary+
                element.profile_2_male+element.profile_2_female+element.profile_2_no_binary+
                element.profile_3_male+element.profile_3_female+element.profile_3_no_binary+
                element.profile_4_male+element.profile_4_female+element.profile_4_no_binary+
                element.profile_5_male+element.profile_5_female+element.profile_5_no_binary); } );
  }
    
  return ( total_quantity );
    
};

const RenderTotalTeachersWorkers = ({ record, ...props }) => {
    
  let total_teachers = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.teachers_workers) total_teachers+=element.teachers_workers; } );
  }
    
  return ( total_teachers );
    
};

const RenderTotalTeachersVolunteers = ({ record, ...props }) => {
    
  let total_teachers = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.teachers_volunteers) total_teachers+=element.teachers_volunteers; } );
  }
    
  return ( total_teachers );
    
};

export const UsersHealthyShow = ({ ...props }) => {
  const translate = useTranslate();   

  return (
        
    <ResourceContextProvider value="users_healthy" >
      <List 
        syncWithLocation 
        basePath="/users_healthy" 
        filter={{ users_id : props.users_id }}  
        title=""
        bulkActionButtons={false}                                
        perPage={1000}
        sort={{ field: 'year', order: 'ASC' }} 
        pagination={false}
        actions={false}
        empty={<></>}
        className="users_remittances_list"
      >                            
        <Datagrid
          expand={<UsersHealthyDetails />} 
          className="header_grey6"
          fullWidth
          props
        >   
          <TextField source="year" label={translate('common.year')} sortable={false}  />                  
          <FunctionField label={translate('users_healthy.total_quantity')} render={record => <RenderTotalQuantity record={record} /> } sortable={false} />
          <FunctionField label={translate('users_healthy.total_teachers_workers')} render={record => <RenderTotalTeachersWorkers record={record} /> } sortable={false} /> 
          <FunctionField label={translate('users_healthy.total_teachers_volunteers')} render={record => <RenderTotalTeachersVolunteers record={record} /> } sortable={false} /> 
        </Datagrid>

      </List> 

    </ResourceContextProvider>            

  );
};


export const CustomToolbar = ({ ...props }) => {

  return (
        
    <TopToolbar>
      <CustomCreateButton users_id={props.users_id} />
    </TopToolbar>
        
  );
};


export const CustomCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('users_healthy');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
    

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };


  return (
    <>            
      <Button onClick={handleClick} label={translate('users_healthy.create_button')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('users_healthy.create')}
      >
        <DialogTitle>{translate('users_healthy.create')}</DialogTitle>

        <FormWithRedirect
          resource="users_healthy"
          save={handleSubmit}
          initialValues={{ users_id : props.users_id }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <CustomForm edit={false} />
                            
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};



const CustomForm = ({ edit, ...props }) => {
  const translate = useTranslate(); 
  const classes = useStyles();
    
  return (
    <DialogContent className="users_activities_form">
      <br />
      <Grid container spacing={2} >
        <Grid item xs={3}>  
          { edit ? (
            <NumberInput label={translate('common.year')} fullWidth source="year" step={1} disabled />                                        
          ) : (
            <NumberInput label={translate('common.year')} fullWidth source="year" step={1} validate={[required(),validateInteger(translate('common.validation.number'))]} />                           
          )}
        </Grid> 
      </Grid>
                
      <ArrayInput source="items" label="" >
        <SimpleFormIterator 
          disableReordering                     
        >
            <SelectInput source="type" label={translate('users_healthy.type')} fullWidth validate={required()} choices={choicesHealthyType(translate)} />
            <FormDataConsumer>
                {({ scopedFormData, getSource }) =>
                  scopedFormData?.type === 99 ? (
                    <TextInput
                      source={getSource('type_other')}
                      label={translate('users_healthy.type_other')}
                      validate={[validateMaxLength(255, translate('common.validation.maxLength'))]}
                      fullWidth
                    />
                  ) : null
                }
            </FormDataConsumer>
            
            <SelectInput source="formal" label={translate('users_healthy.formal')} fullWidth choices={choicesHealthyFormal(translate)} resettable />
            
            <FormDataConsumer>
                {({ scopedFormData, getSource }) =>
                  scopedFormData?.formal === 1 ? (
                    <SelectInput source={getSource('federation')} label={translate('users_healthy.federation')} fullWidth choices={choicesHealthyFederation(translate)}  />
                  ) : null
                }
            </FormDataConsumer>
                
            <FormDataConsumer>
                {({ scopedFormData, getSource }) =>
                  scopedFormData?.formal === 1 && scopedFormData?.federation != null && scopedFormData?.federation === 99 ? (
                    <TextInput
                      source={getSource('federation_other')}
                      label={translate('users_healthy.federation_other')}
                      validate={[validateMaxLength(255, translate('common.validation.maxLength'))]}
                      fullWidth
                    />
                  ) : null
                }
            </FormDataConsumer>
            
            <FormDataConsumer>
                {({ scopedFormData, getSource }) =>
                  scopedFormData?.formal === 1 ? (
                    <NumberInput fullWidth source={getSource('federation_licenses')} step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.federation_licenses')} />
                  ) : null
                }
            </FormDataConsumer>            

            <NumberInput fullWidth source="teachers_workers" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.teachers_workers')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput fullWidth source="teachers_volunteers" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.teachers_volunteers')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <SelectInput fullWidth source="periodicity" label={translate('users_healthy.periodicity')} choices={choicesHealthyPeriodicity(translate)}  />
            
            
            <span className="form-healthy-profiles">{translate('users_healthy.profile')}</span>
            
            <br/> 
            <span className="form-healthy">{translate('users_healthy.profile_1')}</span>
            <NumberInput className="form-healthy" source="profile_1_female" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_1_female')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_1_male" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_1_male')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_1_no_binary" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_1_no_binary')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
                        
            <span className="form-healthy">{translate('users_healthy.profile_2')}</span>
            <NumberInput className="form-healthy" source="profile_2_female" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_2_female')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_2_male" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_2_male')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_2_no_binary" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_2_no_binary')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
                        
            <span className="form-healthy">{translate('users_healthy.profile_3')}</span>
            <NumberInput className="form-healthy" source="profile_3_female" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_3_female')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_3_male" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_3_male')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_3_no_binary" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_3_no_binary')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            
            <span className="form-healthy">{translate('users_healthy.profile_4')}</span>
            <NumberInput className="form-healthy" source="profile_4_female" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_4_female')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_4_male" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_4_male')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_4_no_binary" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_4_no_binary')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            
            <span className="form-healthy">{translate('users_healthy.profile_5')}</span>
            <NumberInput className="form-healthy" source="profile_5_female" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_5_female')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_5_male" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_5_male')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            <NumberInput className="form-healthy" source="profile_5_no_binary" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_healthy.profile_5_no_binary')} parse={(value) => value == null || value === '' ? 0 : Number(value)} />
            
        </SimpleFormIterator>
      </ArrayInput>
                        
    </DialogContent>
  );
    
    
};
    
  
export const UsersHealthyDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  let total_quantity = 0;
  if (record.items)
  {
    record.items.forEach(element => { total_quantity+=1; } );
  }
        
  let total_students = 0;
  if (record.items)
  {
    record.items.forEach(element => { total_students+=(element.profile_1_male+element.profile_1_female+element.profile_1_no_binary+
                element.profile_2_male+element.profile_2_female+element.profile_2_no_binary+
                element.profile_3_male+element.profile_3_female+element.profile_3_no_binary+
                element.profile_4_male+element.profile_4_female+element.profile_4_no_binary+
                element.profile_5_male+element.profile_5_female+element.profile_5_no_binary); } );
  }
    
  let total_teachers_workers = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.teachers_workers) total_teachers_workers+=element.teachers_workers; } );
  }
    
  let total_teachers_volunteers = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.teachers_volunteers) total_teachers_volunteers+=element.teachers_volunteers; } );
  }
        
  return (
    <div className="usersEconomicDataExpand">
      <Grid container spacing={2}>
        <Grid item xs={2} >
          <FunctionField render={record => <TextFieldShow source={record.year} label={translate('common.year')} /> } />
        </Grid>
        <Grid item xs={2} >
          <FunctionField render={record => <TextFieldShow source={total_quantity} label={translate('users_healthy.total_quantity')} /> } />
        </Grid>
        <Grid item xs={2} >
          <FunctionField render={record => <TextFieldShow source={total_students} label={translate('users_healthy.total_students')} /> } />
        </Grid>
        <Grid item xs={2} >
          <FunctionField render={record => <TextFieldShow source={total_teachers_workers} label={translate('users_healthy.total_teachers_workers')} /> } />
        </Grid>
        <Grid item xs={2} >
          <FunctionField render={record => <TextFieldShow source={total_teachers_volunteers} label={translate('users_healthy.total_teachers_volunteers')} /> } />
        </Grid>
      </Grid>
        
      <br />
      <Divider className="" />
      <br />
      <ArrayField source="items">
        <Datagrid>
          <SelectField source="type" choices={choicesHealthyType(translate)} label={translate('users_healthy.type')} sortable={false} />    
          <TextField source="type_other" label={translate('users_healthy.type_other')} />          
          <SelectField source="formal" choices={choicesHealthyFormal(translate)} label={translate('users_healthy.formal')} sortable={false} />
          <SelectField source="federation" choices={choicesHealthyFederation(translate)} label={translate('users_healthy.federation')} sortable={false} />
          <TextField source="federation_other" label={translate('users_healthy.federation_other')} />       
          <TextField source="federation_licenses" label={translate('users_healthy.federation_licenses')} /> 
          <TextField source="teachers_workers" label={translate('users_healthy.teachers_workers')} />
          <TextField source="teachers_volunteers" label={translate('users_healthy.teachers_volunteers')} />
                  
          <SelectField source="periodicity" choices={choicesHealthyPeriodicity(translate)} label={translate('users_healthy.periodicity')} sortable={false} />
          
          <TextField source="profile_1_female" label={translate('users_healthy.profile_1') + ' ' + translate('users_healthy.profile_1_female')} /> 
          <TextField source="profile_1_male" label={translate('users_healthy.profile_1') + ' ' + translate('users_healthy.profile_1_male')} /> 
          <TextField source="profile_1_no_binary" label={translate('users_healthy.profile_1') + ' ' + translate('users_healthy.profile_1_no_binary')} /> 
          
          <TextField source="profile_2_female" label={translate('users_healthy.profile_2') + ' ' + translate('users_healthy.profile_2_female')} /> 
          <TextField source="profile_2_male" label={translate('users_healthy.profile_2') + ' ' + translate('users_healthy.profile_2_male')} /> 
          <TextField source="profile_2_no_binary" label={translate('users_healthy.profile_2') + ' ' + translate('users_healthy.profile_2_no_binary')} /> 
          
          <TextField source="profile_3_female" label={translate('users_healthy.profile_3') + ' ' + translate('users_healthy.profile_3_female')} /> 
          <TextField source="profile_3_male" label={translate('users_healthy.profile_3') + ' ' + translate('users_healthy.profile_3_male')} /> 
          <TextField source="profile_3_no_binary" label={translate('users_healthy.profile_3') + ' ' + translate('users_healthy.profile_3_no_binary')} /> 
          
          <TextField source="profile_4_female" label={translate('users_healthy.profile_4') + ' ' + translate('users_healthy.profile_4_female')} /> 
          <TextField source="profile_4_male" label={translate('users_healthy.profile_4') + ' ' + translate('users_healthy.profile_4_male')} /> 
          <TextField source="profile_4_no_binary" label={translate('users_healthy.profile_4') + ' ' + translate('users_healthy.profile_4_no_binary')} /> 
          
          <TextField source="profile_5_female" label={translate('users_healthy.profile_5') + ' ' + translate('users_healthy.profile_5_female')} /> 
          <TextField source="profile_5_male" label={translate('users_healthy.profile_5') + ' ' + translate('users_healthy.profile_5_male')} /> 
          <TextField source="profile_5_no_binary" label={translate('users_healthy.profile_5') + ' ' + translate('users_healthy.profile_5_no_binary')} /> 
          
          
                  
        </Datagrid>
      </ArrayField>
        
      <br /> 
    </div>
  );
};

